// Account verification rules, in one place.
//
// The login response carries `mail_verify` and `phone_verify`, e.g.
//   { phone_verify: 0, mail_verify: 2, uemail: "...", umobile: "..." }
// Only the values in VERIFIED_VALUES count as verified; 0, 2, null, etc. do not.
// By default an account counts as verified when EITHER channel is verified.
// Set REQUIRE_BOTH = true to demand both.
export const REQUIRE_BOTH = false;
const VERIFIED_VALUES = ["1"];

const isVerifiedValue = (v) => v === true || VERIFIED_VALUES.includes(String(v));

let warned = false;

export const isAccountVerified = (user) => {
  if (!user?.sopnoid) return false;

  // Safety net: if the API stops sending both flags we can't tell, and locking
  // every user out on a missing field would be worse than skipping the gate.
  if (user.mail_verify === undefined && user.phone_verify === undefined) {
    if (!warned) {
      warned = true;
      console.warn(
        "Account has no mail_verify / phone_verify fields — treating it as verified."
      );
    }
    return true;
  }

  const mail = isVerifiedValue(user.mail_verify);
  const phone = isVerifiedValue(user.phone_verify);
  return REQUIRE_BOTH ? mail && phone : mail || phone;
};

// Contact details from the login response (uemail / umobile), with a few
// fallbacks for other endpoints that name them differently.
export const getAccountContact = (user) => ({
  userId: String(user?.userId ?? user?.sopnoid ?? ""),
  name: user?.uname ?? "",
  email: String(user?.uemail ?? user?.email ?? user?.Email ?? user?.p_email ?? ""),
  phone: String(
    user?.umobile ?? user?.phone ?? user?.Phone ?? user?.MobileNumber ?? user?.p_phone ?? ""
  ).replace(/\D/g, ""),
  phoneCode: user?.phoneCode ?? user?.phone_code ?? "",
});